// extracted by mini-css-extract-plugin
export default {"tx":"_814fc37e70","line":"_6c129491a8"};